import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/NotFound.css';

const NotFound: React.FC = () => {
    return (
        <div className="not-found">
            <h1>404 - Página no encontrada</h1>
            <p>Lo sentimos, la página que estás buscando no existe.</p>
            <Link to="/">Volver al inicio</Link>
        </div>
    );
};

export default NotFound;